import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";
import { api } from "../../admin/api";

export const UploadZone = ({ onUploaded, label = "Görseli sürükleyin veya seçin", testid = "upload-zone" }) => {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file || uploading) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onUploaded(data.path);
    } catch (e) {
      alert("Yükleme başarısız: " + (e.response?.data?.detail || e.message));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      data-testid={testid}
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => { e.preventDefault(); setDragging(false); upload(e.dataTransfer.files[0]); }}
      className={`flex cursor-pointer flex-col items-center justify-center gap-2 border border-dashed px-4 py-8 text-center transition-colors duration-300 ${
        dragging ? "border-ink-900 bg-cream-200" : "border-line bg-cream-100 hover:bg-cream-200"
      }`}
    >
      <UploadCloud size={22} className="text-ink-400" />
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-500">
        {uploading ? "Yükleniyor..." : label}
      </p>
      <p className="text-[10px] text-ink-400">JPG, PNG veya WebP — maks 10 MB</p>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        onChange={(e) => { upload(e.target.files[0]); e.target.value = ""; }}
      />
    </div>
  );
};
